{
  "components": {
    "settings": {
      "yourAvatar": "Your avatar",
      "uploadImage": "Upload image",
      "uploadNewImage": "Upload new image",
      "updateSettings": {
        "successMessage": "Settings updated successfully",
        "errorMessage": "Failed to update settings"
      },
      "addDelegate": {
        "title": "Add Delegate",
        "description": "Select a coworker to delegate your tasks and responsibilities to when you are unavailable.",
        "label": "Delegate",
        "placeholder": "Select a coworker...",
        "successMessage": "Delegate settings updated successfully",
        "errorMessage": "Failed to update delegate settings",
        "clear": "Remove delegate"
      },
      "additionalEmail": {
        "label": "Additional notification email",
        "placeholder": "Enter email address...",
        "successMessage": "Notification email updated successfully",
        "errorMessage": "Failed to update notification email",
        "invalidEmail": "Please enter a valid email address"
      }
    }
  }
}
